/**
 * Checks if an error response indicates a duplicate site name violation.
 * This can occur through two paths:
 * 1. Database constraint violation (site_entity_id_name_idx)
 * 2. Error message containing the constraint name (fallback)
 *
 * @param errorData - The error response data from an API call
 * @returns true if the error is a duplicate site name error
 */
export const isDuplicateSiteNameError = (errorData) => {
    if (!errorData || typeof errorData !== 'object') {
        return false;
    }
    const data = errorData;
    return (data.details?.constraint === 'site_entity_id_name_idx' ||
        (typeof data.error === 'string' && data.error.includes('site_entity_id_name_idx')));
};
